"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgStorm(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12.442 14.654c.136 0 .245.104.245.229a.222.222 0 01-.027.098l-.933 2.525 2.16-.535c.021-.005.043-.01.065-.01.071 0 .136.032.185.081.06.066.077.158.038.24l-2.944 6.308a.259.259 0 01-.229.137c-.022 0-.049-.006-.076-.011-.12-.038-.191-.153-.164-.267l1.074-4.406-2.214.551c-.021.005-.043.005-.065.005a.264.264 0 01-.169-.06.213.213 0 01-.07-.212l1.095-4.499a.243.243 0 01.24-.174zM10.167.119c2.015 0 3.74 1.192 4.464 2.893a2.389 2.389 0 011.564-.564c1.328 0 2.411 1.046 2.411 2.329 0 .464-.141.891-.386 1.255 1.601.364 2.797 1.747 2.797 3.403 0 1.866-1.517 3.392-3.424 3.489l-.192.005H7.153c-2.327 0-4.22-1.829-4.22-4.076 0-1.629.999-3.039 2.43-3.685a5.283 5.283 0 01-.019-.391c0-2.575 2.158-4.658 4.823-4.658zm3.575 5.167l-1.988 2.68-1.991-2.68L8.166 7.67l1.905 2.57h3.372l1.9-2.563-1.601-2.392z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgStorm;
exports.default = _default;